import Chip from '@mui/material/Chip';
import type {SxProps} from '@mui/system';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {getStatusLabel} from '@/components/common/forestMassStatusLabels';
import {DEFAULT_STATUS_PROPS, STATUS_PROPS} from '@/config';
import type {STATUS} from '@/domain/entities/ForestMassStatus';

//TYPES
type Props = {
  id: STATUS;
};

const ChipStatus: FC<Props> = ({id}) => {
  const {t} = useTranslation();
  const props = STATUS_PROPS[id] ?? DEFAULT_STATUS_PROPS;

  const styles: Record<string, SxProps> = {
    chip: {
      width: 'fit-content',
      borderRadius: 0,
      fontWeight: 900,
      bgcolor: props.bgcolor,
      color: props.color,
    },
  };

  const label = getStatusLabel(id, t);

  return <Chip variant={props.variant} label={label} sx={styles.chip} />;
};
export default ChipStatus;
